export default __webpack_public_path__ + "static/media/duck@3x.0f94e0be.png";